import { Box, Drawer } from '@mui/material';
import { Button } from '@smiles/voebiz-ui-kit';
import React, { ReactNode, forwardRef } from 'react';
import { isMobile } from 'react-device-detect';

type Anchor = 'left' | 'right';

interface DrawerModalProps {
  children: ReactNode;
  anchor?: Anchor;
  open: boolean;
  id: string;
  onClose: () => void;
  hideheader?: boolean;
}

const DrawerModal = forwardRef<HTMLElement, DrawerModalProps>((props, ref) => {
  const anchor: Anchor = props.anchor || 'right';

  return (
    <Drawer anchor={anchor} {...props} data-testid={props.id}>
      <Box className="summary-drawer" ref={ref}>
        {!props.hideheader && (
          <Box className="summary-drawer-header" data-testid={`close-${props.id}`}>
            <Button
              icon={<i className="material-icons">{isMobile ? 'close' : 'chevron_left'}</i>}
              fill={false}
              type="pill"
              variant="circle"
              onClick={props.onClose}
              id={props.id}
            />
          </Box>
        )}
        {props.children}
      </Box>
    </Drawer>
  );
});

export default DrawerModal;
